// extracted by mini-css-extract-plugin
export default {"details":"accordion_details__Sf4TO","summary":"accordion_summary__59X87","open":"accordion_open__xzKK8","content":"accordion_content__Y4+gQ"};